

class UserLogin {
    constructor() {
       
        this.user_Name = null;
        this.password = null;
        this.fcmToken = ""
    }
}

export default UserLogin;